import getUserResumeById from './getUserResumeById.js';
import { saveAs } from 'file-saver';

/**
 * Fetches a resume by its ID and triggers a download of the resume as a JSON file.
 * @param {string} resumeId - The ID of the resume to download.
 */
const downloadResumeAsJson = async (resumeId) => {
  try {
    const resumeData = await getUserResumeById(resumeId);
    const jsonString = JSON.stringify(resumeData, null, 2);
    const blob = new Blob([jsonString], { type: 'application/json;charset=utf-8' });

    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const filename = `simple-resume-${year}-${month}-${day}_${hours}-${minutes}.json`;

    saveAs(blob, filename);
  } catch (error) {
    console.error('Failed to download resume:', error);
    return error
  }
};

export default downloadResumeAsJson;